import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { TrialDialogService } from '@pyg-services/trial-dialog.service';
import { NavigateComponent } from '@pyg-components/navigate/navigate.component';
import { RouterOutlet } from '@angular/router';
import { LinksComponent } from '@pyg-components/links/links.component';
import { FooterComponent } from '@pyg-components/footer/footer.component';
import { FreeTrialComponent } from '@pyg-shared/free-trial/free-trial.component';
import { MetaService } from '@pyg-services/meta/meta.service';
import { StaticPagesService } from '@pyg-services/static-pages.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    NavigateComponent,
    RouterOutlet,
    LinksComponent,
    FooterComponent,
    FreeTrialComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly metaService = inject(MetaService);
  private readonly trialDialog = inject(TrialDialogService);
  private readonly staticService = inject(StaticPagesService);

  public readonly trialData = this.trialDialog.trialData;
  public readonly isStaticPage = this.staticService.isStaticPage;

  constructor() {
    this.metaService.init(this.destroyRef);
  }
}
